<template>
  <input type="file" @change='change' ref="inputRef">
</template>

<script>
  import { Buffer } from 'buffer'

  export default {
    data () {
      return {}
    },
    props: {
      type: {
        required: false,
        type: String,
        default: 'Buffer' /* 'Buffer' | 'String' | 'Object' */
      }
    },
    methods: {
      change () {
        const reader = new FileReader()
        const file = this.$refs.inputRef.files[0]
        const blob = file.slice(0, file.size)
        const enc = new TextDecoder()

        reader.addEventListener('loadend', event => {
          let output = ({
            Buffer: res => Buffer.from(res),
            String: res => enc.decode(res),
            Object: res => JSON.parse(enc.decode(res))
          })[this.type](event.target.result)

          this.$emit('change', file.name, output)
        })

        reader.readAsArrayBuffer(blob)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/vue-file.vue